export default __webpack_public_path__ + "static/do-maintain-spatial-anchors-82a45f169d9bd88229eb6e52b9bb5385416ccc7ba5f61243b8982483809947c7.png";